<template>
    <div class="body">
        <div style="text-align: center; padding-bottom: 1rem;">
            <div style="font-size: 2rem; font-weight: bold; margin-bottom: 2rem;">
                拉新
            </div>
        </div>

        <p style="text-align: center;">
            系统剩余库存：{{remainStock}}
        </p>

        <van-button round size="large" type="primary" @click="snapOrder">
            一键抢单
        </van-button>
        <p style="font-weight: bold; font-size: 2rem;">
            注意：<br />
            1. 抢单后1小时内必须将凭证提交审核 <br />
            2. 必须要先抢到单后再根据做单链接做单，抢一单做一单，否则不予结算
        </p>

        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="list">
            <table style="width: 100%">
                <tr v-for="row in detailList" :key="row.id">
                    <td style="text-align:left; padding-bottom: 2rem;">
                        <van-cell title="订单号" :value="row.id"/>
                        <van-cell title="做单链接" :value="row.link" is-link :url="row.link" v-if="row.status === 0" />
                        <van-cell title="抢单时间" :value="row.snapTime"/>
                        <van-cell title="报单状态" :value="row.status === 0 ? '未报单' : '已报单'"/>
                        <div v-if="row.status === 0" style="text-align:center">
                            <van-button round size="small" type="primary" @click="showCompleteDialog(row)">
                                点击报单
                            </van-button>
                            <van-button round size="small" type="info" style="margin-left:5rem;" @click="returnOrder(row)">
                                退回订单
                            </van-button>
                        </div>
                    </td>
                </tr>
            </table>
        </van-list>

        <van-dialog title="提交信息" v-model="completeOrderDialog" style="width: 80%;" show-cancel-button
                    @confirm="completeOrder()" @cancel="cancelOrderDialog">
            <div style="text-align: center; padding: 1rem;">
                <van-field label="提交手机号" v-model="phone" placeholder="点击输入手机号"></van-field>
                <van-row>
                    <van-col span="12">
                        图片上传样例1
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="12">
                        <img :src="exampleImg1" @click="previewExampleImg1"/>
                    </van-col>
                    <van-col span="12">
                        <div class="uploader_box">
                            <input type="file" id="logimg1" accept="image/*" @change="onRead(1)"/>
                            <img v-if="imgUrl1" :src="imgUrl1"/>
                            <img v-else-if="camera" :src="camera"/>
                        </div>
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="12">
                        图片上传样例2
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="12">
                        <img :src="exampleImg2" @click="previewExampleImg2"/>
                    </van-col>
                    <van-col span="12">
                        <div class="uploader_box">
                            <input type="file" id="logimg2" accept="image/*" @change="onRead(2)"/>
                            <img v-if="imgUrl2" :src="imgUrl2"/>
                            <img v-else-if="camera" :src="camera"/>
                        </div>
                    </van-col>
                </van-row>
            </div>
        </van-dialog>

        <van-dialog title="做单须知" v-model="informDialog" style="width: 65%; padding: 0 2rem;">
            <p>
                1. 抢单后1小时内必须将凭证提交审核
            </p>
            <p>
                2. 严禁提交虚假凭证，一经发现，直接审核失败且关闭该账号的任务权限
            </p>
            <p>
                3. 如发生异常情况，请第一时间联系客服寻求帮助
            </p>
        </van-dialog>
    </div>
</template>

<script>
    import grabOrderAPI from '@/api/grabOrder';
    import camera from '@/assets/images/camera.png';
    import {ImagePreview} from "vant";

    export default {
        data() {
            return {
                query: {
                    traderId: this.$route.query.traderId,
                    type: 2,
                    limit: 30,
                    page: 1,
                },
                phone: '',
                detailList: [],
                loading: false,
                finished: false,
                completeOrderDialog: false,
                returnOrderDialog: false,
                informDialog: true,
                row: {},
                exampleImg1: 'http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NoBTlcD.png',
                exampleImg2: 'http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NoBTjfc.png',
                imgUrl1: '',
                imgUrl2: '',
                camera: camera,
                remainStock: 0,
            }
        },
        created() {
            this.getRemainStock();
        },
        methods: {
            previewExampleImg1() {
                ImagePreview([
                    this.exampleImg1,
                ]);
            },
            previewExampleImg2() {
                ImagePreview([
                    this.exampleImg2,
                ]);
            },
            onRead(index) { // 上传图片到图片服务器
                let file = document.getElementById('logimg' + index).files[0];

                let self = this;
                let reader = new FileReader();
                reader.onload = e => {
                    let result = e.target.result;
                    let formData = new FormData();
                    formData.append("dirName", "任务报单上传目录");

                    if (result.length / 1024 > 500) {
                        let img = new Image();
                        img.src = result;
                        img.onload = function () {
                            self.$toast("开始压缩图片...");
                            //0.6为压缩的程度，数值越小，压缩的文件越小，图片也会越模糊
                            let src = self.$myUtil.compressImg(img, 0.6);
                            formData.append("file", self.$myUtil.base64ImgDataToFile(src, file.name));
                            self.uploadImg(formData, index);
                        }
                    } else {
                        formData.append("file", file);
                        self.uploadImg(formData, index);
                    }
                };
                // 读取图像
                reader.readAsDataURL(file);
            },
            //上传图片
            uploadImg(formData, index) {
                this.$toast("开始上传图片...");
                this.$http.post('/sys/ossFileMapping/upload', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res => {
                    if (index == 1) {
                        this.imgUrl1 = res.data;
                    } else if (index == 2) {
                        this.imgUrl2 = res.data;
                    }
                    this.$toast("图片上传成功");
                }).catch(() => {
                    this.$toast("图片上传失败");
                })
            },
            list() {
                if (!this.query.traderId) {
                    this.$toast("页面参数有误，请重新进入页面");
                    return;
                }
                this.loading = true;
                grabOrderAPI.list(this.query).then((result) => {
                    this.query.page++;
                    if (result.data.rows.length === 0) {
                        this.finished = true;
                    } else {
                        this.detailList.push(...result.data.rows);
                        this.detailList.map(item => {
                            item.snapTime = this.$myUtil.parseTime(item.snapTime);
                        })
                    }
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            },
            getRemainStock() {
                grabOrderAPI.getRemainStock(2).then((result) => {
                    this.remainStock = result.data;
                }).catch(() => {
                })
            },
            reload() {
                this.query.page = 1;
                this.detailList = [];
                this.list();
                this.getRemainStock();
            },
            snapOrder() {
                let d = new Date();
                if (d.getHours() >= 22) {
                    this.$toast("超过22点无法抢单，请明日再试");
                    return;
                }
                grabOrderAPI.snapOrder(this.query.traderId, this.amount, 2).then(() => {
                    this.$toast("抢单成功");
                    this.reload();
                }).catch(() => {
                })
            },
            showCompleteDialog(row) {
                this.completeOrderDialog = true;
                this.row = row;
            },
            completeOrder() {
                if (!this.phone) {
                    this.$toast("请填写手机号");
                    return;
                }
                if (!this.imgUrl1 || !this.imgUrl2) {
                    this.$toast("请先上传凭证");
                    return;
                }
                grabOrderAPI.completeOrder(this.row.id, this.imgUrl1, this.imgUrl2, this.phone, this.query.traderId).then(() => {
                    this.$toast("做单成功");
                    this.reload();
                }).catch(() => {
                });
            },
            cancelOrderDialog() {
                this.imgUrl1 = '';
                this.imgUrl2 = '';
            },
            returnOrder(row) {
                this.$dialog.confirm({
                    title: '退回订单',
                    message: '确定要退回该订单吗'
                }).then(() => {
                    // on confirm
                    grabOrderAPI.returnOrder(row.id, this.query.traderId).then(() => {
                        this.$toast("退单成功");
                        this.reload();
                    }).catch(() => {
                    })
                }).catch(() => {
                    // on cancel
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .all {
        background-color: #FFFFFF;
    }

    .body {
        background: url("http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NoBW9Qn.png") no-repeat;
        background-size: 100% 100%;
        padding: 2rem 2rem;
        line-height: 2.5rem;
        p {
            text-align: left;
            color: #000000;
        }
        img {
            height: 12rem;
            width: 7rem;
        }

    }

    .uploader_box {
        width: 100%;
        height: auto;
        overflow: hidden;
        position: relative;
    }

    .uploader_box > input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }

</style>
